import { FC, useCallback } from 'react'
import { Button } from '@mui/material'
import { useNotify, useRefresh, useTranslate, useUpdate } from 'react-admin'
import { ScheduleOut, ScheduleStatus } from '../../types/apiRequests'

interface Props {
  schedule: ScheduleOut
}

const ScheduleCancelButton: FC<Props> = ({ schedule }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const [update, { isLoading }] = useUpdate()

  const handleCancel = useCallback(() => {
    void update(
      'schedule',
      { id: schedule.id, data: { status: ScheduleStatus.CANCELED } },
      {
        onSuccess: () => {
          notify('resources.schedule.actions.canceled', { type: 'info' })
          refresh()
        },
        onError: () => notify('ra.notification.http_error', { type: 'warning' }),
      }
    )
  }, [notify, refresh, update, schedule.id])

  if (schedule.status !== ScheduleStatus.PENDING) return null

  return (
    <Button
      variant="outlined"
      color="warning"
      size="small"
      onClick={handleCancel}
      disabled={isLoading}
    >
      {translate('resources.schedule.actions.cancel', { _: 'Annuleren' })}
    </Button>
  )
}

export default ScheduleCancelButton
